import React, { FC } from 'react'
import styles from './EmptyText.module.scss'

interface Props {
  text: string
}
const EmptyText: FC<Props> = ({ text }: Props) => <div className={styles.documentEmpty}>No {text} were found that were created by you</div>

export default EmptyText
